export default __webpack_public_path__ + "static/media/cupomDescontoVexado.5655271f.webp";